module.exports = __webpack_public_path__ + "static/media/pillar-titles-new.da4ab452.svg";